import React, { useState, useEffect, useContext } from "react"
import styled from "styled-components"
import { FaCalendar } from "@react-icons/all-files/fa/FaCalendar"
import { SectionContext } from "../../context/sectionContext"
import { ConditionContext } from "../../context/conditionContext"
import { JourneyContext } from "../../context/journeyContext"
import { getValueFromJourney, isEquitasChannel } from "../../services/helperFunctions"
import { lineCapital } from "../../../shared/functions"
import * as moment from "moment"
import { dateFormat2, dateFormat1 } from '../../../shared/constant'
import { ErrorContext } from "../../context/errorContext"

import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import range from "lodash/range"
import { getYear, getMonth } from "date-fns"
import { isIE } from 'react-device-detect';
import DateHeaderSelect from "../DateHeaderSelect"
const years = range(1920, getYear(new Date()) + 1, 1)
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
]


const DateContainer = styled.div`
  display: block;
  flex-direction: column;
  margin: 15px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 14px;
  color: #505050;
  float: left;

  & > .date-input {
    display: flex;
    position: relative;
    border: 1px solid #929292;
    padding:0;
    padding-left: 10px;
    z-index:2;
    .react-datepicker-popper{
      transform: translate(26px, 69px) scale(1.2) !important;
      left:8rem !important;
      @media screen and (max-width:767px){
        transform: translate(26px,69px) scale(1.2) !important;
        left: 4rem !important;
      }
    }
    input {
      width: 100%;
      border: none;
      outline: none;
      z-index: 5;
      background: transparent;
      
      &:before{
        content: attr(value);
      }


      &[value=""]:before{
        content: attr(format);
      }


      &::-webkit-calendar-picker-indicator {
        color: rgba(0, 0, 0, 0);
        opacity: 0;
        cursor: pointer;
      }
      &::-webkit-datetime-edit, &::-webkit-inner-spin-button, &::-webkit-clear-button {
        opacity: 0;
      }

    }

    .input-icon {
      position: absolute;
      right: 1rem;
      cursor: pointer;
      bottom: -5px;
      & > * {
        color: ${props => props.channel === "A" ? "#db0011" : props.channel === "B" ? "#a20a3a" : props.channel === "C" ? "#fec32b" : "#eb7f25"};
        color: var(--lumiq-tertiary);
      }
    }
  }

  & > label {
    margin-left: 8px;
    margin-bottom: 2px;
    color: #505050;
    font-size: 14px;
    background: ${props => props.channel === "A" ? "#ededed" : "#fff"};
    background:var(--lumiq-bg);
    padding: 2px 5px;
    z-index: 3;
    position: relative;
    display: inline-block;
    cursor: default;
    max-width: 100%;
  }
`
export default function RepeatableComponentTextInputDate(props) {
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [errorState, setErrorState, fieldRefs, crollToFirstError, scrollFieldToTop] = useContext(ErrorContext)
  const [showLocalError, setShowLocalError] = useState(false)
  const [conditionState, setConditionState] = useContext(ConditionContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  let pickerRef = React.createRef();

  const getMaxDate = () => {
    if (props.data.max_age) {
      let currentDate = new Date()
      let maxDateInEpoch = currentDate.setDate(currentDate.getDate() - props.data.max_age)
      let maxDate = new Date(maxDateInEpoch)
      return maxDateInEpoch
    } else {
      return
    }
  }
  const getMinDate = () => {
    if (props.data.min_age) {
      let currentDate = new Date()
      let minDateInEpoch = currentDate.setDate(currentDate.getDate() - props.data.min_age)
      let minDate = new Date(minDateInEpoch)
      return minDateInEpoch
    } else {
      return
    }
  }

  const validate = (target) => {
    let temp
    let temp1
    if (errorState[props.data.formControlKey]) {
      temp1 = errorState[props.data.formControlKey]
    } else {
      temp1 = []
    }
    if (props.data.required) {
      //   required field validation
      if (!sectionState.sectionData[props.data.formControlKey] || !sectionState.sectionData[props.data.formControlKey][props.index]) {
        // console.log("dchdh1", props, sectionState)
        temp1[props.index] =  (getValueFromJourney(
              journeyState.lookup.required_error,
              props.data.requiredError
            ))
        temp = temp1
        setErrorState(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: temp
          })
        })
        return
      }
      if ((sectionState.sectionData[props.data.formControlKey]) && (!sectionState.sectionData[props.data.formControlKey][props.index])) {
        temp1[props.index] =  (getValueFromJourney(
              journeyState.lookup.required_error,
              props.data.requiredError
            ))
        temp = temp1
        setErrorState(prev => {
          // console.log("dchdh2", props, sectionState)
          return ({
            ...prev,
            [props.data.formControlKey]: temp
          })
        })
      } else {
        temp1[props.index] = ""
        temp = temp1
        setErrorState(prev => {
          // console.log("dchdh3", props, sectionState)
          return ({
            ...prev,
            [props.data.formControlKey]: temp
          })
        })
      }
      if (target.value) {
        // console.log("dchdh4", props, sectionState)
        temp1[props.index] = ""
        temp = temp1
        setErrorState(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: temp
          })
        })
      }
    }
    if (target.value) {
      // console.log("insid eseconf if vj", target.value)
      let targetDateInEpoch = target.value

      let currentDateInEpoch = Math.floor((new Date().getTime()) / 1000)
      let timeleft = currentDateInEpoch - targetDateInEpoch
      let days = Math.ceil(((timeleft / 60) / 60) / 24)
      // console.log("time", currentDateInEpoch, targetDateInEpoch, timeleft)

      if (props.data.min_age) { // min age validation
        console.log("inside min age")
        if (days > props.data.min_age) {
          temp1[props.index] =  (getValueFromJourney(
            journeyState.lookup.min_error,
            props.data.min_age_error
          ))

          temp = temp1
          setErrorState(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: temp
            })
          })
          setShowLocalError(true)
          return
        } else {
          temp1[props.index] = ""
          temp = temp1
          setErrorState(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: temp
            })
          })
        }
      }
      if (props.data.max_age) { //max age validation
        // console.log("inside max age", days, props.data.max_age)
        if (days < props.data.max_age) {
          temp1[props.index] =  (getValueFromJourney(
            journeyState.lookup.max_error,
            props.data.max_age_error
          ))

          temp = temp1
          setErrorState(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: temp
            })
          })
          setShowLocalError(true)
          return
        }
        else {
          temp1[props.index] = ""
          temp = temp1
          setErrorState(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: temp
            })
          })
        }
      }
    }
    // console.log(errorState)
    return
  }


  useEffect(() => {
    validate({
      value: (sectionState.sectionData[props.data.formControlKey] ? sectionState.sectionData[props.data.formControlKey][props.index] ?? "" : "")
    })

    handlePicker()

  }, [sectionState.sectionData[props.data.formControlKey]?.[props.index]])

  const handleChange = (target ) => {
    console.log("22322323", target)
    let dateOfTargetInEpoch = (new Date(target).getTime())/1000
    console.log("223223232",dateOfTargetInEpoch)
    let temp
    if (sectionState.sectionData[props.data.formControlKey]) {
      let temp1 = sectionState.sectionData[props.data.formControlKey]
      temp1[props.index] = dateOfTargetInEpoch
      temp = temp1
    } else {
      let temp1 = []
      temp1[props.index] = dateOfTargetInEpoch
      temp = temp1
    }
    if (sectionState.sectionId === props.sectionId) {
      setSectionState(prev => {
        return {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: temp
          },
        }
      })
    } else {
      setSectionState(prev => {
        return {
          ...prev,
          sectionId: props.sectionId,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: temp
          },
        }
      })
    }

    setConditionState(prev => {
      return {
        ...prev,
        [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: temp,
      }
    })
    validate({value: dateOfTargetInEpoch})
    console.log(sectionState, "section state")
  }

  const handlePicker = () => {


    if(pickerRef?.current){

      let picker = pickerRef?.current.querySelector('.input-icon')
      let calender = pickerRef?.current.querySelector('#datepicker')
      
      picker.addEventListener('click',()=>{
        calender.click()
      })
    }
  }

  return (
    <>
      <DateContainer ref={(el) => {
        const key = props.data.formControlKey;

        if (el) {
          fieldRefs.current[key] = el;   // mount
        } else {
          delete fieldRefs.current[key]; // unmount cleanup
        }
      }} channel={props.channel} className={`form-group input-container repeatable-calendar ${props.data.disabled ? 'disable-input' : ''}`}>
        <label htmlFor={props.data.id} className="input-label" >{(getValueFromJourney(
          journeyState.lookup.label,
          props.data.label
        )) || props.data.label}{isEquitasChannel(props.channel) && props.data.required && <span className="equitas-required-marker"> *</span>}</label>
        <div ref={pickerRef} className="date-input form-control">
        <DatePicker
        id="datepicker"

  selected={(sectionState.sectionData[props.data.formControlKey] && sectionState.sectionData[props.data.formControlKey][props.index])
    ? sectionState.sectionData[props.data.formControlKey][props.index] * 1000
    : ""}
  dateFormat={'dd/MMM/yyyy'}
  placeholderText={(getValueFromJourney(
    journeyState.lookup.placeholder,
    props.data.placeholder
  )) || props.data.placeholder}
  className={(isIE ? 'IELineHeight' : '')}
  autoComplete ="false"
  renderCustomHeader={({
    date,
    changeYear,
    changeMonth,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
  }) => (
    <div
      style={{
        margin: 10,
        display: "flex",
        justifyContent: "center",
      }}
      className="repeatable-calendar-header"
    >
      <button
        onClick={decreaseMonth}
        disabled={prevMonthButtonDisabled}
      >
        <span>
                    <svg width="16px" height="16px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g id="SVGRepo_bgCarrier" stroke-width="0" />
                      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />
                      <g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M15.7071 4.29289C16.0976 4.68342 16.0976 5.31658 15.7071 5.70711L9.41421 12L15.7071 18.2929C16.0976 18.6834 16.0976 19.3166 15.7071 19.7071C15.3166 20.0976 14.6834 20.0976 14.2929 19.7071L7.29289 12.7071C7.10536 12.5196 7 12.2652 7 12C7 11.7348 7.10536 11.4804 7.29289 11.2929L14.2929 4.29289C14.6834 3.90237 15.3166 3.90237 15.7071 4.29289Z" fill="#000000" /> </g>
                    </svg>
                  </span>
      </button>
      <DateHeaderSelect
        value={getYear(date)}
        onChange={(value) => changeYear(value)}
        options={years}
      />

      <DateHeaderSelect
        value={months[getMonth(date)]}
        onChange={(value) => changeMonth(months.indexOf(value))}
        options={months}
      />
      <button
        onClick={increaseMonth}
        disabled={nextMonthButtonDisabled}
      >
        <span>
                    <svg width="16px" height="16px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g id="SVGRepo_bgCarrier" stroke-width="0" />
                      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />
                      <g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M8.29289 4.29289C8.68342 3.90237 9.31658 3.90237 9.70711 4.29289L16.7071 11.2929C17.0976 11.6834 17.0976 12.3166 16.7071 12.7071L9.70711 19.7071C9.31658 20.0976 8.68342 20.0976 8.29289 19.7071C7.90237 19.3166 7.90237 18.6834 8.29289 18.2929L14.5858 12L8.29289 5.70711C7.90237 5.31658 7.90237 4.68342 8.29289 4.29289Z" fill="#000000" /> </g>
                    </svg>
                  </span>
      </button>
    </div>
  )}
  minDate={getMinDate()}
  maxDate={getMaxDate()}
  // onSelect={handleDateSelect} //when day is clicked
  onChange={handleChange} //only when value has changed
  onFocus={() => scrollFieldToTop(props.data.formControlKey)}
/>
          {/* <input
            type="date"
            format={dateFormat1}
            placeholder={props.data.placeholder}
            name={props.data.id}
            required={props.data.required}
            disabled={props.data.disabled}
            onChange={handleChange}
            value={
              (sectionState.sectionData[props.data.formControlKey] && sectionState.sectionData[props.data.formControlKey][props.index])
                ? moment.unix(
                  sectionState.sectionData[props.data.formControlKey][props.index]
                ).utcOffset("+05:30").format(dateFormat1).split('T')[0]
                : ""
            }
            min={getMinDate()}
            max={getMaxDate()}
          //dateFormat={props.data.dateFormat}
          //formControlKey={props.data.formControlKey}
          ></input> */}
          <span className="input-icon" aria-hidden="true" onClick={()=>handlePicker()}  >
            <FaCalendar  />
          </span>
        </div>
        <span className="input-error2">
          {(props.showError || showLocalError) && errorState?.[props.data.formControlKey]?.[props.index]}
        </span>
      </DateContainer>
    </>
  )
}
